<table
	mat-table
	matSort
	[dataSource]="dataSource"
	[class.persistent-actions]="template.settings.persistentActions"
	[class.no-paginator]="!showPaginator"
	(matSortChange)="updateSort.emit($event)"
>
	<ng-container [matColumnDef]="column.id" *ngFor="let column of template.settings?.activeColumns; let i = index; trackBy: trackByFn">
		<!-- Header Cell -->
		<th
			mat-header-cell
			*matHeaderCellDef
			mat-sort-header
			[disabled]="!!column.disableSort"
			[resizeColumn]="true"
			[index]="i"
			[style.width]="column.width ? column.width + 'px' : '150px'"
			[style.min-width]="scrollableTable && (column.width ? column.width + 'px' : '150px')"
		>
			{{ column.name }}
		</th>

		<ng-container [ngSwitch]="column.type">
			<!-- Date -->
			<ng-container *ngSwitchCase="'date'">
				<td mat-cell *matCellDef="let element" [class.pointer]="column.linked" (click)="linkEvent(column, element)">
					{{ resolveDotNotationPath(column.path, element) | localizedDate }}
				</td>
			</ng-container>

			<!-- User -->
			<ng-container *ngSwitchCase="'user'">
				<td mat-cell *matCellDef="let element">
					<ng-container *localVar="resolveDotNotationPath(column.path, element) as user">
						{{ user?.nameFirst }} {{ user?.nameLast }}
					</ng-container>
				</td>
			</ng-container>

			<!-- Badge -->
			<ng-container *ngSwitchCase="'badge'">
				<td mat-cell *matCellDef="let element">
					<ng-container *localVar="resolveDotNotationPath(column.path, element) as badge">
						<ng-container *ngIf="badge">
							<mat-chip color="primary" class="m-1 p-2">
								{{ badge.name }}
							</mat-chip>
						</ng-container>
					</ng-container>
				</td>
			</ng-container>

			<!-- Badges -->
			<ng-container *ngSwitchCase="'badges'">
				<td mat-cell *matCellDef="let element">
					<ng-container *localVar="resolveDotNotationPath(column.path, element) as items">
						<span class="tags-list" *ngIf="items?.length">
							<mat-basic-chip disableRipple class="tag-item" *ngFor="let item of items" color="primary">
								{{ column.mapBadgeValueFn ? column.mapBadgeValueFn(item) : item.name || item }}
							</mat-basic-chip>
						</span>
					</ng-container>
				</td>
			</ng-container>

			<!-- Custom function-->
			<ng-container *ngSwitchCase="'custom'">
				<td mat-cell *matCellDef="let element" [class.pointer]="column.linked" (click)="linkEvent(column, element)">
					<a [attr.href]="column.linked?.href ?? null" [innerHtml]="column.valueFn(element)"> </a>
				</td>
			</ng-container>

			<!-- toggle -->
			<ng-container *ngSwitchCase="'toggle'">
				<td mat-cell *matCellDef="let element">
					<ng-container *localVar="resolveDotNotationPath(column.path, element) as value">
						<mat-slide-toggle color="primary" [disabled]="!!column.extra?.disabled || resolveDotNotationPath(column.extra?.disabledCondition?.path, element) === column.extra?.disabledCondition?.value" [checked]="value === true" (change)="column.extra?.action ? onActionEvent(element, column.extra?.action) : false"></mat-slide-toggle>
					</ng-container>
				</td>
			</ng-container>

			<!-- checkbox -->
			<ng-container *ngSwitchCase="'checkbox'">
				<td mat-cell *matCellDef="let element" class="checkbox-cell" (click)="column.extra?.action ? onActionEvent(element, column.extra?.action) : false">
					<ng-container *localVar="resolveDotNotationPath(column.path, element) as value">
						<mat-icon class="checkbox-icon" [class.selected]="value === true">
							{{ value === true ? 'check_box' : 'check_box_outline_blank' }}
						</mat-icon>
					</ng-container>
				</td>
			</ng-container>

			<!-- Default -->
			<ng-container *ngSwitchDefault>
				<td mat-cell *matCellDef="let element" [class.pointer]="column.linked" (click)="linkEvent(column, element)">
					<a [attr.href]="column.linked?.href ?? null" [innerHtml]="resolveDotNotationPath(column.path, element)"> </a>
				</td>
			</ng-container>
		</ng-container>
	</ng-container>

	<ng-container *ngIf="template.settings.actions" matColumnDef="actions" [stickyEnd]="template.settings.stickyActions">
		<th mat-header-cell *matHeaderCellDef></th>
		<td mat-cell *matCellDef="let element">
			<ng-container *ngFor="let action of template.settings.actions" class="ml-2">
				<ng-container *ngIf="!action.condition || collectionUtils.isConditionValid(action.condition, element)">
					<button
						*ngIf="action.id != 'create' && action.type !== ActionType.MENU"
						class="action-button {{ action.classes }}"
						[class.icon-left]="action.showName"
						[class.icon-only]="!action.showName"
						[class.no-icon]="action.showName && !action.icon"
						[class.active]="(action.type === ActionType.SELECT && isSelected(element.id)) || (action.type === ActionType.PIN && element.isPinned)"
						[class.loading]="action.type === ActionType.EXPORT && isLoading(element.id)"
						[disabled]="action.type === ActionType.EXPORT && isLoading(element.id)"
						[matTooltip]="action.showTooltip ? (action.type === ActionType.PIN && element.isPinned ? action.toggleOptions?.onName : action.name) : undefined"
						color="primary"
						(click)="onActionEvent(element, action)"
					>
						<ng-container *ngIf="(action.type === ActionType.SELECT && isSelected(element.id)) || (action.type === ActionType.PIN && element.isPinned); then selected; else unselected">
						</ng-container>

						<ng-template #unselected>
							<ng-container *ngIf="action.type === ActionType.EXPORT && isLoading(element.id); else loaded">
								<mat-spinner [diameter]="20"></mat-spinner>
							</ng-container>
							<ng-template #loaded>
								<mat-icon inline [class.material-symbols-outlined]="action.type === ActionType.PIN && !element.isPinned">{{ action.toggleOptions?.offIcon || action.icon }}</mat-icon>
							</ng-template>

							<span *ngIf="action.showName">{{ action.toggleOptions?.offName || action.name }}</span>
						</ng-template>

						<ng-template #selected>
							<mat-icon inline>{{ action.toggleOptions.onIcon }}</mat-icon>
							<span *ngIf="action.showName">{{ action.toggleOptions.onName }}</span>
						</ng-template>
					</button>

					<button
						*ngIf="action.type === ActionType.MENU"
						class="action-button {{ action.classes }}"
						[class.icon-left]="action.showName"
						[class.icon-only]="!action.showName"
						color="primary"
						[matTooltip]="action.showTooltip ? action.name : undefined"
						[matMenuTriggerFor]="menuAction"
					>
						<mat-icon inline *ngIf="action.icon">{{ action.icon }}</mat-icon>
						<span *ngIf="action.showName">{{ action.name }}</span>

						<mat-menu #menuAction="matMenu" class="tiny">
							<ng-container *ngFor="let menuAction of action.actionSettings" >
							<div 
								*ngIf="!(menuAction.id === 'report' && element.role === superAdmin) && (!menuAction.condition || collectionUtils.isConditionValid(menuAction.condition, element))"  
								mat-menu-item 
								[ngClass]="menuAction.classes" 
								(click)="onActionEvent(element, menuAction)"
							>
								<mat-icon *ngIf="menuAction.icon">{{ menuAction.icon }}</mat-icon>
								<span *ngIf="menuAction.id === 'report' && (element.reporting|| element.role=== superAdmin)">{{disableReportingText}}</span>
								<span *ngIf="menuAction.id === 'report' && (!element.reporting && element.role!== superAdmin) ">{{enableReportingText}}</span>
								<span *ngIf="menuAction.id === 'joinableBusiness' && element.joinableBusiness">{{unmarkAsJoinable}}</span>
								<span *ngIf="menuAction.id === 'joinableBusiness' && !element.joinableBusiness">{{markAsJoinable}}</span>
								<span *ngIf="menuAction.id !== 'report' && menuAction.id !== 'joinableBusiness'">{{ menuAction.name }}</span>
							</div>
						</ng-container>
						</mat-menu>
					</button>
				</ng-container>
			</ng-container>
		</td>
	</ng-container>

	<tr mat-header-row *matHeaderRowDef="activeColumnIds"></tr>
	<tr mat-row class="table-row" *matRowDef="let row; columns: activeColumnIds" 
		[class.selected]="isSelected(row.id)"
		[class.clickable]="template.settings.rowClickable"
		(click)="template.settings.rowClickable ? onRowClick(row) : null"></tr>

	<!-- No Data Message-->
	<tr class="no-data mat-row" *matNoDataRow>
		<td class="mat-cell" colspan="9999">
			<div class="get-started-container">
				<div class="content-container">
					<h2 class="title" i18n="No Data Message@@collectionTableNoDataMessageTitle">We couldn't find any data for this filter set.</h2>
					<p class="description" i18n="No Data Message@@collectionTableNoDataMessageDescription">Try broadening your search or reset your filters below.</p>

					<div class="actions">
						<!-- <button mat-flat-button class="button-extra-small" color="primary" (click)="resetFilters.emit()">
							Reset Filters
						</button> -->
					</div>
				</div>
			</div>
		</td>
	</tr>
</table>
<!-- TODO: IMPROVE BUTTONS -->
<div class="table-footer" [class.show-scrollbar]="scrollableTable">
	<div *ngIf="showCreateButton()" class="buttons-container">
		<button mat-flat-button color="primary" (click)="onActionEvent(null, showCreateButton())">
			<i class="uil-plus"></i>
			<ng-container i18n="Create New Button@@collectionTableCreateNewButton">Create new</ng-container>
		</button>
	</div>
	<mat-paginator
		*ngIf="showPaginator"
		[pageIndex]="page - 1"
		[pageSize]="limit"
		[length]="totalResults"
		[pageSizeOptions]="limitOptions"
		(page)="updatePagination.emit($event)"
	></mat-paginator>
</div>
